import { Box, Flex, Icon, Text, useColorModeValue } from "@chakra-ui/react";
import { useGetLoginInfo } from '@multiversx/sdk-dapp/hooks';
import * as DappUI from "@multiversx/sdk-dapp/UI";
import Card from "components/card/Card";
import { AiFillUsb } from "react-icons/ai";
import { BsPhoneFill } from "react-icons/bs";
import { FaDesktop, FaWallet } from "react-icons/fa";
import { Redirect } from "react-router-dom";

export default function Overview() {
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const { isLoggedIn } = useGetLoginInfo();
  const customToken = process.env.REACT_APP_PUBLIC_TOKEN;

  if (isLoggedIn) {
    return <Redirect to={'/'} />
  }

  return (
    <Box height={'100%'} pt={{ base: "200px"}}>
      <Flex
        justifyContent={'center'}
        gap={{ base: "20px", xl: "20px" }}>
        <Card width="500px">
          <Text
            color={textColor}
            textAlign={'center'}
            fontSize='22px'
            fontWeight='700'
            mb={8}
            mt={6}
            lineHeight='100%'>
            Connect to a wallet
          </Text>
          <DappUI.ExtensionLoginButton
            buttonClassName="btn-connect"
            callbackRoute='/board'
            token={customToken}
          >
              <Icon
                as={FaWallet}
                width='20px'
                height='20px'
                color='inherit'
                />
              <p>Maiar DeFi Wallet</p>
          </DappUI.ExtensionLoginButton>
          <DappUI.WalletConnectLoginButton
            isWalletConnectV2={true}
            buttonClassName="btn-connect"
            callbackRoute='/board'
            token={customToken}
          >
              <Icon
                as={BsPhoneFill}
                width='20px'
                height='20px'
                color='inherit'
                />
              <p>Maiar App</p>
          </DappUI.WalletConnectLoginButton>

          <DappUI.LedgerLoginButton
            buttonClassName="btn-connect"
            callbackRoute='/board'
            token={customToken}
          >
            <>
              <Icon
                as={AiFillUsb}
                width='20px'
                height='20px'
                color='inherit'
                />
              <p>Ledger</p>
            </>
            </DappUI.LedgerLoginButton>
          <DappUI.WebWalletLoginButton
            buttonClassName="btn-connect"
            callbackRoute='/board'
            token={customToken}
          >
            <>
              <Icon
                as={FaDesktop}
                width='20px'
                height='20px'
                color='inherit'
                />
              <p>Elrond Web Wallet</p>
            </>
          </DappUI.WebWalletLoginButton>

        </Card>
      </Flex>
    </Box>
  );
}
